var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1133_12338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#94B909"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1133_12338)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1C3.23864 1 1 3.23864 1 6C1 8.76136 3.23864 11 6 11C8.76136 11 11 8.76136 11 6C11 3.23864 8.76136 1 6 1ZM8.16727 5.15455C8.20718 5.10893 8.23756 5.05579 8.25663 4.99826C8.2757 4.94073 8.28307 4.87996 8.27831 4.81954C8.27354 4.75912 8.25674 4.70026 8.2289 4.64642C8.20105 4.59259 8.16272 4.54487 8.11616 4.50606C8.0696 4.46726 8.01575 4.43816 7.95777 4.42048C7.8998 4.4028 7.83887 4.39689 7.77858 4.4031C7.71829 4.40932 7.65985 4.42752 7.6067 4.45665C7.55355 4.48578 7.50676 4.52525 7.46909 4.57273L5.51455 6.91773L4.50318 5.90591C4.41745 5.82311 4.30263 5.77729 4.18345 5.77833C4.06427 5.77937 3.95027 5.82717 3.86599 5.91145C3.78172 5.99572 3.73391 6.10973 3.73288 6.22891C3.73184 6.34809 3.77766 6.46291 3.86045 6.54864L5.22409 7.91227C5.26875 7.95691 5.32223 7.99175 5.3811 8.01457C5.43997 8.0374 5.50295 8.04771 5.56603 8.04484C5.62911 8.04198 5.6909 8.026 5.74746 7.99793C5.80402 7.96986 5.85411 7.93032 5.89455 7.88182L8.16727 5.15455Z",
    fill: "#94B909"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/Checked.16b252e5944f17a5ec4bfc65a4b9717d.svg";
export { ForwardRef as ReactComponent };